// LocalStorage keys
export const STORAGE_KEYS = {
  GAME_STATE: 'soccerRef_gameState',
  SETTINGS: 'soccerRef_settings',
  GAME_HISTORY: 'soccerRef_gameHistory',
  SAVED_TIME: 'soccerRef_savedTime',
  INSTALL_PROMPT_DISMISSED: 'soccerRef_installPromptDismissed',
} as const;

// Notification settings
export const NOTIFICATION = {
  VIBRATION_PATTERN: [200, 100, 200, 100, 200] as number[],
  BEEP_FREQUENCY: 800,
  BEEP_DURATION: 1.5,
  BEEP_VOLUME: 0.3,
} as const;

// Timer settings
export const TIMER = {
  UPDATE_INTERVAL_MS: 100,
} as const;